import { render, staticRenderFns } from "./InviterDetail.vue?vue&type=template&id=00a5f3a2&scoped=true"
import script from "./InviterDetail.vue?vue&type=script&lang=js"
export * from "./InviterDetail.vue?vue&type=script&lang=js"
import style0 from "./InviterDetail.vue?vue&type=style&index=0&id=00a5f3a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5f3a2",
  null
  
)

export default component.exports